export default __webpack_public_path__ + "static/shutterstock_1-37ec492935ca8c2ee8cee3bb0b01709b.jpg";